import { React, useState } from "react";
import { 
  Image, 
  Button,
  Grid,
  GridRow,
  GridColumn,
} from "semantic-ui-react";
import HamburgerMenu from "./hamburgerMenu";

export default function NavBar(props) {
  const { setSelection } = props
  const [b1Hovered, setB1Hovered] = useState(false)
  const [b2Hovered, setB2Hovered] = useState(false)
  const [b3Hovered, setB3Hovered] = useState(false)

  const menuItemStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    backgroundColor: "transparent",
    color: "#FFFFFF",
    borderBottom: "solid 0.2em transparent",
    borderRadius: "0em",
  }

  const menuItemStyleHover = {
    ...menuItemStyle,
    borderBottom: "solid 0.2em #FFFFFF",
    transition: "color 1s ease, border-bottom-color 1s ease",
  }

  function PageSelectLanding() {
    setSelection("landing");
    window.scrollTo(0, 0);
  }

  function PageSelectAboutUs() {
    setSelection("aboutUs");
    window.scrollTo(0, 0);
  } 

  function PageSelectContactUs() {
    setSelection("contactUs");
    window.scrollTo(0, 0);
  }

  return (
    <nav aria-label="Main navigation">
      <Grid 
        name='navbar' 
        centered 
        container 
        style={{ padding: '2em 1em 2em 1em' }}
      >
        <GridRow only='computer' style={{ zIndex: "1" }}>
          <GridColumn width={8}>
            <Image
              src="./homeButton.svg"
              alt="Home button"
              onClick={PageSelectLanding}
              style={{
                cursor: 'pointer',
                height: '3em',
              }}
            />
          </GridColumn>
          <GridColumn
            width={8}
            textAlign="right"
            verticalAlign="middle"
          >
            <Button
              content='Home'
              aria-label="Navigate to Home"
              onClick={PageSelectLanding}
              onMouseEnter={() => setB1Hovered(true)}
              onMouseLeave={() => setB1Hovered(false)}
              style={b1Hovered ? (menuItemStyleHover) : (menuItemStyle)}
            />

            <Button
              content='About Us'
              aria-label="Navigate to About Us"
              onClick={PageSelectAboutUs}
              onMouseEnter={() => setB2Hovered(true)}
              onMouseLeave={() => setB2Hovered(false)}
              style={b2Hovered ? (menuItemStyleHover) : (menuItemStyle)}
            />
            
            <Button
              content='Contact Us'
              aria-label="Navigate to Contact Us"
              onClick={PageSelectContactUs}
              onMouseEnter={() => setB3Hovered(true)}
              onMouseLeave={() => setB3Hovered(false)}
              style={b3Hovered ? (menuItemStyleHover) : (menuItemStyle)}
            />
          </GridColumn>
        </GridRow>

        <GridRow only="tablet mobile" style={{ zIndex: "1" }}>
          <GridColumn width={8}>
            <Image
              src="./homeButton.svg"
              alt="Home button"
              onClick={PageSelectLanding}
              style={{
                cursor: 'pointer',
                height: '3em',
              }}
            />
          </GridColumn>
          <GridColumn
            width={8}
            textAlign="right"
            verticalAlign="middle"
            style={{
              padding: "0em 1em 0em 0em",
            }}
          >
            <HamburgerMenu setSelection={setSelection} />
          </GridColumn>
        </GridRow>
      </Grid>
    </nav>
  )
}